import Guide from './'

const SnapLine = Guide.extend({

  className: 'snap-line'

})

const VerticalSnapLine = SnapLine.extend({

  type: 'vertical',

  coords: function (from, to, prop) {
    var minY = Math.min(from.top, to.top)
      , maxY = Math.max(from.top + from.height, to.top + to.height)
      , left = to[prop] + this.canvas.padding
      , height = maxY - minY
      , top = minY + this.canvas.padding

    if (prop === 'vertical-middle') {
      left = to.left + this.canvas.padding + to.width / 2
    }

    return { left, height, top, bottom: top + height }
  },
})

const HorizontalSnapLine = SnapLine.extend({

  type: 'horizontal',

  coords: function (from, to, prop) {
    var minX = Math.min(from.left, to.left)
      , maxX = Math.max(from.left + from.width, to.left + to.width)
      , top = to[prop] + this.canvas.padding
      , width = maxX - minX
      , left = minX + this.canvas.padding

    if (prop === 'horizontal-middle') {
      top = to.top + this.canvas.padding + to.height / 2
    }

    return { top, width, left, right: left + width }
  },
})

export const Horizontal = HorizontalSnapLine
export const Vertical = VerticalSnapLine
